import React from 'react';

import { AdaChat } from '@interlayer/js/custom/components/main/FloatingButtons/components/AdaChat';

import style from './FloatingButtons.scss';

export const FloatingButtons: React.FC = () => {
    return (
        <div className={style.container}>
            <AdaChat />
        </div>
    );
};
